//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class TenantTypeService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[TenantType.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/tenant-type/detail', {'params':params});
	};

	//GeneratorFlag:[TenantType.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/tenant-type/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}